import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import { Dropdown, type IDropdownItem } from 'shared/ui'
import { makeTextFieldIcon, TextFieldPlaceholder } from 'shared/ui/TextField'
import { DropdownNumbersContent } from 'pages/settings/pages/compliance/ui/MultiSelectNumbers/DropdownNumbersContent'
import { SelectNumbersTrigger } from 'pages/settings/pages/compliance/ui/MultiSelectNumbers/SelectNumbersTrigger'
import {
  type IMultiselectedItem,
  type INumbersGroup,
} from 'pages/settings/pages/compliance/ui/MultiSelectNumbers/type'
import styles from './styles.module.scss'

type ISkipNumbersProps = {
  multiSelectedValues: IMultiselectedItem[]
  search: string
  setSearch: (search: string) => void
  numbersGroups: INumbersGroup[]
  handleMultiSelect: (item: IDropdownItem) => void
  removeMultiSelectedItem: (item: IMultiselectedItem) => void
  updateDeprioritizeNumbers: () => void
}

export const SkipNumbers = observer(
  ({
    multiSelectedValues,
    search,
    setSearch,
    numbersGroups,
    handleMultiSelect,
    removeMultiSelectedItem,
    updateDeprioritizeNumbers,
  }: ISkipNumbersProps) => {
    return (
      <Dropdown
        ariaLabel={'SkipNumbers'}
        width={311}
        onClose={() => {
          updateDeprioritizeNumbers()
        }}
        triggerComponent={() => (
          <TextFieldPlaceholder
            multiline
            variant='stroke'
            size='medium'
            rightActions={[makeTextFieldIcon({ icon: 'chevronDown' })]}
            className={classNames(styles.selectLabel, {
              [styles.multiSelectPlaceholder]: multiSelectedValues.length,
            })}
            placeholder={
              <SelectNumbersTrigger
                isLoading={false}
                multiSelectedValues={multiSelectedValues}
                limit={2}
                triggerContainerClassName={styles.selectLabelTrigger}
              />
            }
          />
        )}
        customComponent={() => (
          <DropdownNumbersContent
            search={search}
            setSearch={setSearch}
            numbersGroups={numbersGroups}
            isLoading={false}
            isDeselectState={false}
            showSelectAllButton={false}
            setMultipleItem={handleMultiSelect}
            multiSelectedValues={multiSelectedValues}
            removeMultiSelectedItem={removeMultiSelectedItem}
            maxHeight={224}
            maxSelectedListHeight={130}
          />
        )}
        placement={'bottom-start'}
        margin={0}
        PopperProps={{
          modifiers: [
            {
              name: 'offset',
              options: {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                offset: ({ reference }) => {
                  return [0, -reference.height - 4]
                },
              },
            },
          ],
        }}
      />
    )
  }
)
